// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__p48nS","item":"pagination_item__uOu4K"};